import { z } from 'zod';
import { Role, TimestampLike } from './common.js';

export const UserDoc = z.object({
  uid: z.string().min(1),
  email: z.string().email(),
  displayName: z.string().optional(),
  role: Role,
  assignedClientId: z.string().optional(),
  assignedClientIds: z.array(z.string()).max(40).optional(),
  isActive: z.boolean().default(true),
  createdAt: TimestampLike,
  claimsUpdatedAt: TimestampLike.optional(),
});
export type UserDoc = z.infer<typeof UserDoc>;
